import { Flag } from '@src/components';

export function CountryCard({ country }: Readonly<{ country: any }>) {
  return (
    <div className='flex space-x-3 px-5 py-5 bg-wl-background text-wl-on-background rounded-xl items-center'>
      <Flag flagSrc={country.flag} />
      <div className='flex flex-col items-start'>
        <span className='text-sm font-medium text-start text-wl-on-background'>
          {country.name}
        </span>
        <span className='text-xs text-wl-on-background opacity-70'>
          {country.region?.name}
        </span>
      </div>
    </div>
  );
}
